import { CALL_API, getJSON } from 'redux-api-middleware';
import { normalize } from 'normalizr';
import { filters } from 'schemas';
import endpoints from 'api/endpoints';
import types from '../types';

export default () => ({
  [CALL_API]: {
    endpoint: endpoints.FILTERS_API,
    method: 'GET',

    types: [
      types.GET_FILTERS_REQUEST,

      {
        type: types.GET_FILTERS_SUCCESS,
        payload: (action, state, res) => getJSON(res)
          .then(json => normalize(
            json,
            filters.arrayOfFilterSchemas,
          )),
      },

      types.GET_FILTERS_FAILURE,
    ],
  },
});



// WEBPACK FOOTER //
// ./src/api/filters/actions/getFilters.js